module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8yQJ6B/images/9781540262905.jpg?1737821500128",
      "alt": "This image is the cover for the book Jaws of the Jersey Shore, Arcadia Children's Books"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jaws of the Jersey Shore, Arcadia Children's Books\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this middle-grade adaptation of  Shark Attacks of the Jersey Shore , author Patricia Heyer dives into the history and lore of shark attacks along New Jersey's coast. Every summer, thousands of people flock to the boardwalks and beaches of the Jersey Shore looking for fun and relaxation. But some come face to face with much more. A boy paid a gruesome price for teasing a trapped shark in the first recorded attack in 1842. Three bloody attacks of 1960 left one man's limb amputated. The horrific summer of 1916 included seven attacks within two weeks, sparking the man-eating reputation that sharks still have today. These stories and more have been adapted for younger readers brave enough to dive in to our shark-infested waters.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Patricia Heyer\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Patricia Heyer is a local history buff with a special interest in New Jersey folklore and marine science. She has written extensively for both children and adults during her career. Her most recent title,  The Ghostly Tales of the  Jersey Shore,  was released in 2023. Pat is an avid reader, beachcomber, and animal rescue supporter. She resides on the Jersey shore with her husband Rob and their rescue cat, Gracie.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0